import { CenterChildren } from '@editor/components/utilities/layouts';
import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

import { LoadingPlaceholderProps } from './types';

const blur = css`
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const LoadingWrapper = styled(CenterChildren)<LoadingPlaceholderProps>`
  position: absolute;
  height: 100%;
  width: 100%;
  background: ${({ backgroundStyle }): string =>
    backgroundStyle ? 'transparent' : themeStyle.varInkSuperLight};
  z-index: ${themeStyle.zIndexM1};

  ${({ backgroundStyle }): string | typeof blur =>
    backgroundStyle === 'blurred' ? blur : ''}
`;
